// import './time.scss';

export { default } from './Time';
export { default as template } from './time.tpl';
